import lodashGet from "lodash/get";
import MobileDetect from "mobile-detect";

const replaceAll = function (str, search, replacement) {
  return str.split(search).join(replacement);
};

const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  let results = new RegExp(
    "[?&]" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "(=([^&#]*)|&|#|$)"
  ).exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const getTrackingCodeLocal = name => {
  let tc = getParameterByName(name, window.location.href);

  if (tc != null && tc !== "") {
    return tc;
  }
  return null;
};

const obtenerTrackingCode = function () {
  let keys = ["cid", "onsite", "ema", "psm", "dis", "afi", "afl"];
  let tc = "";

  for (let key of keys) {
    let tccan = getTrackingCodeLocal(key);
    if (tccan !== null) {
      tc = tccan;
      break;
    }
  }

  if (tc === "") {
    return "";
  }

  let tcSplit = "";
  let tcBuild = "";

  if (tc.indexOf(":") === -1) {
    // Tracking codes viejos
    tcSplit = tc.split("-");
  } else {
    // Tracking codes nuevos
    replaceAll(tc, "_", " ");
    tcSplit = tc.split("-")[0].split(":");
  }

  tcBuild =
    tcSplit[0].trim() +
    "-" +
    tcSplit[1].trim() +
    "-" +
    tcSplit[2].trim() +
    "-" +
    tcSplit[3].trim();

  return "-" + tcBuild;
};

const toTitleCase = function (str) {
  if (!!str && str.trim() !== "") {
    return str.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
  return str;
};

const isDev = function () {
  return !PRODUCTION;
};

const isValidDate = function (dateString) {
  // Verificar patrón
  let regex_date = /\d{2}\/\d{2}\/\d{4}/;

  if (!regex_date.test(dateString)) {
    return false;
  }

  // Parsear string de fecha
  let parts = dateString.split("/");
  let day = parseInt(parts[0], 10);
  let month = parseInt(parts[1], 10);
  let year = parseInt(parts[2], 10);

  // Rango de meses y años
  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
    return false;
  }

  let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Ajustar años biciestos
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
    monthLength[1] = 29;
  }

  // Verificar rango de días
  return day > 0 && day <= monthLength[month - 1];
};

/**
 * Normalizar caracteres reemplazando acentuados por
 * sus equivalentes no acentuados
 */
const normalizeCharacters = str => {
  /** 2021-07-06: Merlin no normaliza las ENIES vienen como ? */
  return str
    ? (str + "")
        .replace(/[?=]/g, "N")
        .replace(/[#=]/g, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    : str;
};

//formatea con separador de mil
const formatMoney = amount => {
  let amountInt = parseInt(amount);
  if (!amountInt) {
    return amount;
  }
  let valor = new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS"
  }).format(amount);
  return valor;
};
/* eslint-disable no-useless-escape */
/**
 * Verificar por el userAgent si el dispositivo es
 * mobile o no
 */
const _isMobile = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.mobile() !== null;
};

const campania = process.env.VUE_APP_CAMP || "ofertaAutomotor";

const nombreMotorTagging = () => {
  /**
   * @warning: MODIFICAR también duplicado en digitalData.js
   */
  const mapeoMotor = {
    ofertaAutomotor: "cotizador vehicular",
    ofertaHogar: "cotizador hogar"
  };

  return mapeoMotor[campania];
};

/**
 * Función de orden superior de lodash.get
 * que convierte null a undefined
 */
const get = (o, path, defval) => {
  return lodashGet(o, path, defval) === null
    ? defval
    : lodashGet(o, path, defval);
};

const getEnvironment = () => {
  const currentHostname = window.location.hostname;
  const prodHosts = ["www.bbva.com.ar", "bbva.com.ar", "apps.bbva.com.ar"];
  const testHosts = ["app-work.bbva.com.ar"];

  // Check if the current hostname matches any of the known hostnames
  if (prodHosts.includes(currentHostname)) {
    return {
      name: "prod",
      description: "Produccion",
      adobeLaunch:
        "//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-144c155dcd64.min.js"
    };
  } else if (testHosts.includes(currentHostname)) {
    return {
      name: "qa",
      description: "Test",
      adobeLaunch:
        "//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"
    };
  }

  // No identificado? usar development
  return {
    name: "de",
    description: "Desarrollo",
    adobeLaunch:
      "//assets.adobedtm.com/95c3e405673d/81c80ecf6aaf/launch-8bd807155300-development.min.js"
  };
};

export {
  isDev,
  _isMobile,
  replaceAll,
  toTitleCase,
  formatMoney,
  isValidDate,
  getEnvironment,
  getParameterByName,
  nombreMotorTagging,
  normalizeCharacters,
  obtenerTrackingCode,
  getTrackingCodeLocal,
  get,
  campania
};
